import { x, y } from 'd3-force/src/simulation'
import { quadtree } from 'd3-quadtree'
import constant from 'd3-force/src/constant'
import jiggle from 'd3-force/src/jiggle'

export default function () {
	let nodes
	let node
	let alpha
	let random
	let strength = constant(-30)
	let strengths
	let distanceMin2 = 1
	let distanceMax2 = Infinity
	let theta2 = 0.81

	function force (_) {
		let i
		const n = nodes.length
		const tree = quadtree(nodes, x, y).visitAfter(accumulate)
		for (alpha = _, i = 0; i < n; ++i) {
			node = nodes[i]
			tree.visit(apply)
		}
	}

	function initialize () {
		if (!nodes) return
		let i
		const n = nodes.length
		let node
		strengths = new Array(n)
		for (i = 0; i < n; ++i) {
			node = nodes[i]
			strengths[node.index] = +strength(node, i, nodes)
		}
	}

	function accumulate (quad) {
		let strength = 0
		let q
		let c
		let weight = 0
		let x
		let y
		let i

		// For internal nodes, accumulate forces from child quadrants.
		if (quad.length) {
			for (x = y = i = 0; i < 4; ++i) {
				if ((q = quad[i]) && (c = Math.abs(q.value))) {
					strength += q.value
					weight += c
					x += c * q.x
					y += c * q.y
				}
			}
			quad.x = x / weight
			quad.y = y / weight
		} else {
			// For leaf nodes, accumulate forces from coincident quadrants.
			q = quad
			q.x = q.data.x
			q.y = q.data.y
			while (q) {
				strength += strengths[q.data.index]
				q = q.next
			}
		}
		quad.value = strength
	}

	function apply (quad, x1, _, x2) {
		if (!quad.value) return true

		let x = quad.x - node.x
		let y = quad.y - node.y
		let w = x2 - x1
		let l = x * x + y * y

		// Apply the Barnes-Hut approximation if possible.
		// Limit forces for very close nodes; randomize direction if coincident.
		if (w * w / theta2 < l) {
			if (l < distanceMax2) {
				if (x === 0) {
					x = jiggle(random)
					l += x * x
				}
				if (y === 0) {
					y = jiggle(random)
					l += y * y
				}
				if (l < distanceMin2) l = Math.sqrt(distanceMin2 * l)
				node.vx += x * quad.value * alpha / l
				node.vy += y * quad.value * alpha / l
			}
			return true
		} else {
			// Otherwise, process points directly.
			if (quad.length || l >= distanceMax2) return
		}

		// Limit forces for very close nodes; randomize direction if coincident.
		if (quad.data !== node || quad.next) {
			if (x === 0) {
				x = jiggle(random)
				l += x * x
			}
			if (y === 0) {
				y = jiggle(random)
				l += y * y
			}
			if (l < distanceMin2) l = Math.sqrt(distanceMin2 * l)
		}
		while (quad) {
			if (quad.data !== node) {
				w = strengths[quad.data.index] * alpha / l
				node.vx += x * w
				node.vy += y * w
			}
			quad = quad.next
		}
	}

	force.initialize = function (_, __) {
		nodes = _.filter((n) => !n.hostId)
		random = __
		initialize()
	}

	force.strength = function (_) {
		if (arguments.length) {
			strength = typeof _ === 'function' ? _ : constant(+_)
			initialize()
			return force
		} else {
			return strength
		}
	}

	force.distanceMin = function (_) {
		if (arguments.length) {
			distanceMin2 = _ * _
			return force
		} else {
			return Math.sqrt(distanceMin2)
		}
	}

	force.distanceMax = function (_) {
		if (arguments.length) {
			distanceMax2 = _ * _
			return force
		} else {
			return Math.sqrt(distanceMax2)
		}
	}

	force.theta = function (_) {
		if (arguments.length) {
			theta2 = _ * _
			return force
		} else {
			return Math.sqrt(theta2)
		}
	}

	return force
}
